import React from "react"

const SectionTitle = ({ children }) => (
  <h4 className="segment title">{children}</h4>
)

export default SectionTitle



// WEBPACK FOOTER //
// ./src/small/SectionTitle.js